





























































import { onMounted, ref, watch } from "@vue/composition-api";
import { BCalendar, BCol, BFormGroup, BFormRadio, BFormRadioGroup, BOverlay, BRow, BTime } from "bootstrap-vue";
import stepHeader from "@/views/modules/engage/create/components/stepHeader.vue";
import engagePopover from "@/views/modules/engage/components/engagePopover.vue";
import useEngageForm from "@/views/modules/engage/useEngageForm";
import { getUserData } from "@/auth/getUserData";
import { DateTime } from "luxon";
import "vue-date-pick/dist/vueDatePick.css";
import DatePick from "vue-date-pick";

export default {
    components: {
        engagePopover,
        stepHeader,
        BFormGroup,
        BFormRadio,
        BCalendar,
        BTime,
        BRow,
        BCol,
        BFormRadioGroup,
        BOverlay,
        DatePick,
    },
    setup() {
        const { currentStep, selectSchedule, setScheduleIsEnabled } = useEngageForm();
        const isScheduled = ref(false);
        const now = new Date();
        const dateValue = ref(String(now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate()));
        const timeContext = ref(null);

        const userSettings = getUserData().settings;
        // || { value: "24" }; in case of we don't get the timeNotation
        const userTimeFormat = userSettings.find((elem) => elem.name === "timeNotation") || { value: "24" };
        // if the format is 12 it will be true and if 24 false
        const timeFormatIs12 = ref(userTimeFormat.value === "12");

        const minDate = DateTime.now();
        const timeValue = ref(timeFormatIs12 ? minDate.toFormat("HH:mm") : minDate.toFormat("hh:mm"));

        const { selectedEngageToEdit } = useEngageForm();
        if (selectedEngageToEdit.value) {
            const dateFromEdit = new Date(selectedEngageToEdit.value.sendAt.toJSDate());
            dateValue.value = String(
                dateFromEdit.getFullYear() + "-" + (dateFromEdit.getMonth() + 1) + "-" + dateFromEdit.getDate()
            );
            isScheduled.value = Boolean(selectedEngageToEdit.value?.sendAt);
            timeValue.value = timeFormatIs12
                ? selectedEngageToEdit.value.sendAt.toFormat("HH:mm")
                : selectedEngageToEdit.value.sendAt.toFormat("hh:mm");
        }

        watch(dateValue, () => {
            addTimeToDate();
        });

        const onContextCalendar = () => {
            if (timeContext.value) {
                addTimeToDate();
            }
        };

        const onContextTime = (ctxTime) => {
            timeContext.value = ctxTime;
            addTimeToDate();
        };

        const addTimeToDate = () => {
            const dateValueDate = new Date(dateValue.value);
            const dateGoodFormat = DateTime.fromISO(dateValueDate.toISOString()).set({
                hour: timeContext.value.hours,
                minute: timeContext.value.minutes,
            });
            selectSchedule(dateGoodFormat);
        };

        onMounted(() => {
            setScheduleIsEnabled(isScheduled.value);
        });

        watch(isScheduled, (nval) => {
            setScheduleIsEnabled(nval);
        });

        return {
            dateValue,
            isScheduled,
            timeValue,
            currentStep,
            userTimeFormat,
            onContextCalendar,
            onContextTime,
        };
    },
};
